import { z } from "zod";

  export const schemaCadastroPessoaEvento = z.object({
    psEvRecStatus: z.any(),
    psEvObservacao:z.string()
  })

  export type CadastroPessoaEventoFormProps = z.infer<typeof schemaCadastroPessoaEvento>;
